import React from "react";
import PropTypes from "prop-types";

import SectionContainer from "core/SectionContainer";
import PhotoUploadToolbarSelectedControls from "./PhotoUploadToolbarSelectedControls";
import PhotoUploadToolbarOtherControls from "./PhotoUploadToolbarOtherControls";

import { useEditPhotoUpload } from "../PhotoUpload/Edit/EditPhotoUploadContext";
import { useSelect } from "../PhotoUpload/hooks/useSelect";
import { useUploadsCurrentlyProcessing } from "../PhotoUploadCore/hooks";

import { ControlsContainer, SelectedControlsContainer } from "./styles";

const PhotoUploadToolbar = ({ uploadsInDropzoneCount = 0 }) => {
    const { openEditModal } = useEditPhotoUpload();
    const {
        count: uploadsCurrentlyProcessingCount
    } = useUploadsCurrentlyProcessing();
    const {
        isSelectAllChecked,
        quantityChecked,
        handleSelectAllChange
    } = useSelect();

    if (!uploadsInDropzoneCount && !uploadsCurrentlyProcessingCount) {
        return null;
    }

    return (
        <SectionContainer
            removeLeftRightPadding
            topSpacing="none"
            bottomSpacing="2xl"
        >
            <ControlsContainer>
                <SelectedControlsContainer>
                    {!!uploadsInDropzoneCount && (
                        <PhotoUploadToolbarSelectedControls
                            openEditModal={openEditModal}
                            isSelectAllChecked={isSelectAllChecked}
                            quantityChecked={quantityChecked}
                            handleSelectAllChange={handleSelectAllChange}
                        />
                    )}
                </SelectedControlsContainer>
                <PhotoUploadToolbarOtherControls />
            </ControlsContainer>
        </SectionContainer>
    );
};

PhotoUploadToolbar.propTypes = {
    uploadsInDropzoneCount: PropTypes.number.isRequired
};

export default PhotoUploadToolbar;
